"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = exports.TFoot = exports.TBody = exports.THead = exports.TRow = exports.TCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var className = function className(props) {
  return (0, _classnames.default)('Table', {
    'Table--full-width': props.fullWidth
  }, {
    'Table--borderless': props.variation === 'borderless',
    'Table--striped': props.variation === 'striped',
    'Table--bordered': props.variation === 'bordered'
  }, {
    'Table--centered': props.centered
  }, {
    'Table--highlight': props.highlight
  }, {
    'Table--white': props.white
  }, props.className);
};

var TCell = function TCell(props) {
  var children = props.children,
      head = props.head,
      style = props.style;

  if (head) {
    return _react.default.createElement("th", _extends({}, (0, _omit.default)(props, ['head']), {
      className: "Table__hcell",
      style: style
    }), children);
  }

  return _react.default.createElement("td", _extends({}, (0, _omit.default)(props, ['head']), {
    className: "Table__cell",
    style: style
  }), children);
};

exports.TCell = TCell;

var TRow = function TRow(_ref) {
  var children = _ref.children,
      head = _ref.head;
  return _react.default.createElement("tr", {
    className: "Table__row"
  }, _react.default.Children.map(children, function (child, key) {
    return _react.default.cloneElement(child, _objectSpread({}, child.props, {
      key: key,
      head: child.props.head || head
    }));
  }));
};

exports.TRow = TRow;

var THead = function THead(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("thead", {
    className: "Table__header"
  }, _react.default.Children.map(children, function (child, key) {
    return _react.default.cloneElement(child, _objectSpread({}, child.props, {
      key: key,
      head: true
    }));
  }));
};

exports.THead = THead;

var TBody = function TBody(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("tbody", {
    className: "Table__body"
  }, children);
};

exports.TBody = TBody;

var TFoot = function TFoot(_ref4) {
  var children = _ref4.children;
  return _react.default.createElement("tfoot", {
    className: "Table__footer"
  }, children);
};

exports.TFoot = TFoot;

var Table = function Table(props) {
  var children = props.children,
      style = props.style;
  return _react.default.createElement("table", _extends({}, (0, _omit.default)(props, ['fullWidth', 'variation', 'centered', 'highlight', 'white']), {
    className: className(props),
    style: style
  }), children);
};

exports.Table = Table;
var _default = Table;
exports.default = _default;